import React from 'react'; 
import {Button, FormGroup, ControlLabel, FormControl,
        Glyphicon, Row, Col, ButtonToolbar, Table} from 'react-bootstrap';
import {injectIntl} from 'react-intl';
import {inject, observer} from 'mobx-react';
import IgBusinessStore from './stores/IgBusinessStore';
import EditableTextarea from '../common_components/EditableTextarea';
import LeanBlockIcon from './LeanBlockIcon';

@injectIntl @inject("rootStore") @observer
export default class LeanForm extends React.Component{

  constructor(props){
    super(props);

    this.state = {
      text: "",
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  render(){
    const {intl} = this.props;
    const block = this.props.rootStore.igBusinessStore.currentBlock;
    const activityEdit = this.props.rootStore.activityStore.activityEdit;
    const label = (
        <span className="bold normalized-label">
          <LeanBlockIcon block={block} />&nbsp;
          {intl.formatMessage({id: ("lean-block-"+block)})}
        </span>
      );
    const saveLabel = intl.formatMessage({id: "save"});
    const cancelLabel = intl.formatMessage({id: "cancel"});
    return( 
      <div>
        <Row>
          <Col xs={12}>
            <div>
              {label}
            </div>

            <br/>
            <FormGroup
              controlId="description"
              >
              <ControlLabel>{intl.formatMessage({id: "description"})}</ControlLabel>
              <FormControl value={this.state.text}
                onChange={this.handleChange} type="text" />
            </FormGroup>
          </Col>
          <Col xs={12} className="text-right">
            <ButtonToolbar>
              <Button bsStyle="primary" onClick={this.handleSubmit}>
                {intl.formatMessage({id: "add"})}
              </Button>
            </ButtonToolbar>
          </Col>
        </Row>
          <span className="bold"></span><br />
          <div className="costs-table">
            <Table striped bordered condensed hover>
              <tbody>
                { activityEdit.getLeanBlockElements(block).map( (el, idx) => 
                      <tr key={idx}>
                        <td>
                          <div className="lean-element">
                            {el.description}
                            <Glyphicon className="btn-transparent clickable"
                              glyph="trash" onClick={() => activityEdit.removeLeanElement(block, el.id)}>
                            </Glyphicon>
                          </div>
                        </td>
                      </tr>
                )}
              </tbody>
            </Table>
          </div>
      </div>
 
    );
  }

  handleSubmit(){
    const block = this.props.rootStore.igBusinessStore.currentBlock;
    this.props.rootStore.activityStore.activityEdit.addLeanDetails(block, this.state.text);
    this.setState({
      text: "",
    })
  }

  handleChange(e){
    this.setState({
      text: e.target.value
    })
  }

}